exports.init = function ($body, src, poster) {
    if($.flash.available){
        $body.flash({
            swf: "https://tianyu.res.netease.com/gw/14v4/player/player.swf",
            width: "100%",
            height: "100%",
            wmode: 'transparent',
            allowscriptaccess:"always",
            allowFullScreen:"true",
            flashvars:{
                v1: src,
                v2: src
            }
        });
    }

    // 360 ie9兼容模式下，flash播放器无法播放，也使用video播放视频
    if(navigator.userAgent.indexOf('compatible; MSIE 9.0;') > -1 || !$.flash.available){
        $body.html(
            '<video width="100%" height="100%" controls="controls" autoplay=true style="background-color: #000;" poster="' + poster + '">' +
                '<source src="' + src + '" type="video/mp4">' +
            '</video>'
        );
    }
}



//////////////////
// WEBPACK FOOTER
// ./pages/anniversary/js/videoPlayer.js
// module id = 5
// module chunks = 2